import React from "react"

import GET_SURVEY_RESULT_EMAIL from "../../../graphql/queries/getSurveyResultEmail"
import useAppSyncQuery from "../../../hooks/useAppSyncQuery"
import FailureDialog from "../components/failureDialog"

const useGetSurveyResultEmail = (surveyId, code, emailIndividualResult, enabledOnMount = false) => {
  const { data, getData, isLoading, errors } = useAppSyncQuery(GET_SURVEY_RESULT_EMAIL, {
    variables: { surveyId, code },
    isPublic: true,
    reRender: [emailIndividualResult],
    enabledOnMount
  })

  if (errors) return <FailureDialog onRetry={getData} />

  return { data, getData, isLoading }
}

export default useGetSurveyResultEmail
